import type { Components, Theme } from "@mui/material/styles";

import { MuiAccordion } from "./accordion";
import { MuiAccordionSummary } from "./accordion-summary";
import { MuiAlert } from "./alert";
import { MuiAlertTitle } from "./alert-title";
import { MuiAppBar } from "./app-bar";
import { MuiAutocomplete } from "./autocomplete";
import { MuiButton } from "./button";
import { MuiButtonGroup } from "./button-group";
import { MuiCard } from "./card";
import { MuiCardActions } from "./card-actions";
import { MuiCardContent } from "./card-content";
import { MuiCardHeader } from "./card-header";
import { MuiCheckbox } from "./checkbox";
import { MuiChip } from "./chip";
import { MuiCssBaseline } from "./css-baseline";
import { MuiDialog } from "./dialog";
import { MuiDialogActions } from "./dialog-actions";
import { MuiDialogContent } from "./dialog-content";
import { MuiDialogTitle } from "./dialog-title";
import { MuiFilledInput } from "./filled-input";
import { MuiFormHelperText } from "./form-helper-text";
import { MuiFormLabel } from "./form-label";
import { MuiIconButton } from "./icon-button";
import { MuiInput } from "./input";
import { MuiInputAdornment } from "./input-adornment";
import { MuiInputBase } from "./input-base";
import { MuiInputLabel } from "./input-label";
import { MuiLink } from "./link";
import { MuiList } from "./list";
import { MuiListItem } from "./list-item";
import { MuiListItemText } from "./list-item-text";
import { MuiListSubheader } from "./list-subheader";
import { MuiMenuItem } from "./menu-item";
import { MuiOutlinedInput } from "./outlined-input";
import { MuiPaper } from "./paper";
import { MuiPopover } from "./popover";
import { MuiPopper } from "./popper";
import { MuiRadio } from "./radio";
import { MuiSelect } from "./select";
import { MuiSkeleton } from "./skeleton";
import { MuiSlider } from "./slider";
import { MuiSvgIcon } from "./svg-icon";
import { MuiSwitch } from "./switch";
import { MuiTab } from "./tab";
import { MuiTable } from "./table";
import { MuiTableCell } from "./table-cell";
import { MuiTableHead } from "./table-head";
import { MuiTableRow } from "./table-row";
import { MuiTabs } from "./tabs";
import { MuiTextField } from "./text-field";
import { MuiToolbar } from "./toolbar";
import { MuiTooltip } from "./tooltip";
import { MuiTypography } from "./typography";

export const components: Components<Theme> = {
  MuiAccordion,
  MuiAccordionSummary,
  MuiAlert,
  MuiAlertTitle,
  MuiAppBar,
  MuiAutocomplete,
  MuiButton,
  MuiButtonGroup,
  MuiCard,
  MuiCardActions,
  MuiCardContent,
  MuiCardHeader,
  MuiCheckbox,
  MuiChip,
  MuiCssBaseline,
  MuiDialog,
  MuiDialogActions,
  MuiDialogContent,
  MuiDialogTitle,
  MuiFilledInput,
  MuiFormHelperText,
  MuiFormLabel,
  MuiIconButton,
  MuiInput,
  MuiInputAdornment,
  MuiInputBase,
  MuiInputLabel,
  MuiLink,
  MuiList,
  MuiListItem,
  MuiListItemText,
  MuiListSubheader,
  MuiMenuItem,
  MuiOutlinedInput,
  MuiPaper,
  MuiPopover,
  MuiPopper,
  MuiRadio,
  MuiSelect,
  MuiSkeleton,
  MuiSlider,
  MuiSvgIcon,
  MuiSwitch,
  MuiTab,
  MuiTable,
  MuiTableCell,
  MuiTableHead,
  MuiTableRow,
  MuiTabs,
  MuiTextField,
  MuiToolbar,
  MuiTooltip,
  MuiTypography,
};
